<template>
    <div class="nevs-content">
        <ModalSendEmail @done="sendEmailDone" :show="sendEmailModal.show" :documentId="sendEmailModal.documentId" :customerId="sendEmailModal.customerId" endpoint="offers"></ModalSendEmail>
        <ModalSendEmailSmtp @done="sendEmailDone" :show="sendEmailSmtpModal.show" :documentId="sendEmailSmtpModal.documentId" :customerId="sendEmailSmtpModal.customerId" endpoint="offers" :defaultSubject="sendEmailSmtpModal.defaultSubject" :defaultBody="sendEmailSmtpModal.defaultBody"></ModalSendEmailSmtp>
        <div class="nevs-content-top-buttons">
            <NevsButton class="primary help-add" @click="addClick">
                <i class="fa-solid fa-plus"></i>
                {{ $LANG.Get('buttons.add') }}
            </NevsButton>
            <NevsButton class="primary" @click="excelClick">
                <i class="fa-solid fa-file-excel"></i>
                {{ $LANG.Get('buttons.excel') }}
            </NevsButton>
            <NevsTableFilters ref="filterPanel" :summary="filterSummary" @clear="clearFilter"
                              @toggle="filtersToggled">
                <NevsTextField v-model="tableData.filters.number" :label="$LANG.Get('fields.number')"></NevsTextField>
                <NevsSelect :nullable="true" v-model="tableData.filters.customer_id" :ajax="'select/customers'"
                            :label="$LANG.Get('fields.customer')"
                            @select="filterLabels.customer_id = $event.label"></NevsSelect>
                <NevsDateField v-model="tableData.filters.date_of_issue_from"
                               :label="$LANG.Get('fields.date_of_issue_from')"></NevsDateField>
                <NevsDateField v-model="tableData.filters.date_of_issue_to"
                               :label="$LANG.Get('fields.date_of_issue_to')"></NevsDateField>
                <NevsSelect :nullable="true" v-model="tableData.filters.offer_status_id" :ajax="'select/offer-statuses'"
                            :label="$LANG.Get('fields.status')"
                            @select="filterLabels.offer_status_id = $event.label"></NevsSelect>
                <NevsTextField v-model="tableData.filters.item" :label="$LANG.Get('fields.item')"></NevsTextField>
            </NevsTableFilters>
        </div>
        <NevsCard>
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadTable">
                <tr v-for="(item, key) in tableData.records" :key="key">
                    <td class="nevs-table-linked-cell help-edit" @click="openClick(item.id)">{{ item.number }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.date_of_issue_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)"
                        :title="item.customer_display">{{ $HELPERS.ShortCustomer(item.customer_display) }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)"><span
                        :class="'status-pill-' + item.offer_status_id">{{ item.status_display }}</span></td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.links_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.amount_display }}</td>
                    <td class="nevs-table-actions">
                        <NevsActions :width="'200px'" :actions="tableActions" :context="item"></NevsActions>
                    </td>
                </tr>
            </NevsTable>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTableFilters from "@/components/nevs/NevsTableFilters.vue";
import NevsActions from "@/components/nevs/NevsActions.vue";
import ModalSendEmail from "@/components/modals/ModalSendEmail.vue";
import ModalSendEmailSmtp from "@/components/modals/ModalSendEmailSmtp.vue";

export default {
    name: "ModuleOffers",
    components: {NevsTableFilters, NevsActions, ModalSendEmail, ModalSendEmailSmtp, NevsSelect, NevsDateField, NevsTextField, NevsTable, NevsButton, NevsCard},
    data() {
        return {
            sendEmailModal: {
                show: false,
                documentId: null,
                customerId: null
            },
            sendEmailSmtpModal: {
                show: false,
                documentId: null,
                customerId: null,
                defaultSubject: '',
                defaultBody: ''
            },
            tableData: {
                fields: [
                    {
                        name: 'number',
                        label: this.$LANG.Get('fields.number')
                    },
                    {
                        name: 'date_of_issue',
                        label: this.$LANG.Get('fields.dateOfIssue')
                    },
                    {
                        name: 'customer',
                        label: this.$LANG.Get('fields.customer'),
                        sortable: false
                    },
                    {
                        name: 'status',
                        label: this.$LANG.Get('fields.status'),
                        sortable: false
                    },
                    {
                        name: 'connections',
                        label: this.$LANG.Get('labels.connections'),
                        sortable: false
                    },
                    {
                        name: 'amount',
                        label: this.$LANG.Get('labels.amount')
                    },
                    {
                        name: 'actions',
                        width: '200px',
                        label: '',
                        sortable: false
                    }
                ],
                filters: {
                    number: '',
                    date_of_issue_from: null,
                    date_of_issue_to: null,
                    offer_status_id: null,
                    customer_id: null,
                    item: ''
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                defaultSort: {
                    field: 'number',
                    descending: true
                },
                filterTimer: null,
                height: '0px'
            },
            tableActions: [
                {
                    label: this.$LANG.Get('tooltips.openInNewWindow'),
                    action: (item) => {
                        this.openClick(item.id, true);
                    },
                    visible: () => {
                        return true;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.pdf'),
                    action: (item) => {
                        this.pdfClick(item.pdf_link);
                    },
                    visible: () => {
                        return true;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.email'),
                    action: (item) => {
                        this.emailClick(item);
                    },
                    visible: () => {
                        return true;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.createInvoice'),
                    action: (item) => {
                        this.invoiceClick(item.id);
                    },
                    visible: () => {
                        return true;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.createDispatchNote'),
                    action: (item) => {
                        this.dispatchNoteClick(item.id);
                    },
                    visible: () => {
                        return true;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.createWorkOrder'),
                    action: (item) => {
                        this.workOrderClick(item.id);
                    },
                    visible: () => {
                        return !this.$store.state.user.client.hidden_modules.includes('workOrders') && this.$store.state.user.work_order_sequences.length > 0;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.copy'),
                    action: (item) => {
                        this.copyClick(item.id);
                    },
                    visible: (item) => {
                        return item.invoice_status_id !== 5;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.delete'),
                    action: (item) => {
                        this.deleteClick(item);
                    },
                    visible: (item) => {
                        return item.deletable;
                    }
                },
            ],
            // Labels of the select filters, for the collapsed filter panel's summary. v-model only
            // carries the id, so the label is captured from NevsSelect's `select` event.
            filterLabels: {
                customer_id: '',
                offer_status_id: ''
            },
            crossTabHandle: null
        }
    },
    computed: {
        // Entries whose value is empty are dropped by NevsTableFilters, so every filter can be listed
        // here and the panel picks the active ones.
        filterSummary() {
            let filters = this.tableData.filters;
            return [
                {
                    name: 'number',
                    label: this.$LANG.Get('fields.number'),
                    value: filters.number
                },
                {
                    name: 'customer_id',
                    label: this.$LANG.Get('fields.customer'),
                    value: filters.customer_id === null ? '' : this.filterLabels.customer_id
                },
                {
                    name: 'date_of_issue_from',
                    label: this.$LANG.Get('fields.date_of_issue_from'),
                    value: filters.date_of_issue_from === null ? '' : this.$HELPERS.FormatDate(filters.date_of_issue_from)
                },
                {
                    name: 'date_of_issue_to',
                    label: this.$LANG.Get('fields.date_of_issue_to'),
                    value: filters.date_of_issue_to === null ? '' : this.$HELPERS.FormatDate(filters.date_of_issue_to)
                },
                {
                    name: 'offer_status_id',
                    label: this.$LANG.Get('fields.status'),
                    value: filters.offer_status_id === null ? '' : this.filterLabels.offer_status_id
                },
                {
                    name: 'item',
                    label: this.$LANG.Get('fields.item'),
                    value: filters.item
                }
            ];
        }
    },
    watch: {
        'tableData.filters': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadTable(vm.tableData.lastRequest);
                    vm.filterTimerOn = false;
                }, 500);
            },
            deep: true
        }
    },
    methods: {
        emailClick(offer) {
            if (this.$store.state.user.client.use_smtp) {
                this.sendEmailSmtpModal.documentId = offer.id;
                this.sendEmailSmtpModal.customerId = offer.customer_id;
                this.sendEmailSmtpModal.defaultSubject = this.$store.state.user.client.offer_email_subject;
                this.sendEmailSmtpModal.defaultBody = this.$store.state.user.client.offer_email_body;
                this.sendEmailSmtpModal.show = true;
            } else {
                this.sendEmailModal.documentId = offer.id;
                this.sendEmailModal.customerId = offer.customer_id;
                this.sendEmailModal.show = true;
            }
        },
        sendEmailDone(success) {
            this.sendEmailModal.show = false;
            this.sendEmailModal.documentId = null;
            this.sendEmailModal.customerId = null;
            this.sendEmailSmtpModal.show = false;
            this.sendEmailSmtpModal.documentId = null;
            this.sendEmailSmtpModal.customerId = null;
            if (success) {
                this.$CROSS_TAB_BUS.TriggerEvent('reload-offers', {});
            }
        },
        pdfClick(link) {
            window.open(link);
        },
        deleteClick(offer) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.offerDeletionQuestion'), callback: (response) => {
                    if (response) {
                        vm.$API.APICall('delete', 'offers/' + offer.id, {}, (data, success) => {
                            if (success) {
                                vm.$CROSS_TAB_BUS.TriggerEvent('reload-offers', {});
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            });
        },
        // The value each filter has when it is not restricting anything.
        emptyFilters() {
            return {
                number: '',
                date_of_issue_from: null,
                date_of_issue_to: null,
                offer_status_id: null,
                customer_id: null,
                item: ''
            };
        },
        clearFilter(entry) {
            this.tableData.filters[entry.name] = this.emptyFilters()[entry.name];
            if (this.filterLabels[entry.name] !== undefined) {
                this.filterLabels[entry.name] = '';
            }
        },
        // Expanding the panel makes it taller, so the table gets whatever height is left over.
        filtersToggled() {
            this.$nextTick(() => {
                this.resolveWindowResize();
            });
        },
        excelClick() {
            let excelRequest = JSON.parse(JSON.stringify(this.tableData.lastRequest));
            excelRequest.rowsPerPage = 0;

            let vm = this;
            vm.$API.APICall('get', 'offers/excel', excelRequest, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        copyClick(id) {
            this.$router.push('/offers/' + id + '/copy');
        },
        invoiceClick(id) {
            this.$router.push('/invoices/' + id + '/offer');
        },
        dispatchNoteClick(id) {
            this.$router.push('/dispatch-notes/' + id + '/offer');
        },
        workOrderClick(id) {
            this.$router.push('/work-orders/' + id + '/offer');
        },
        openClick(id, newWindow = false) {
            if (newWindow) {
                let routeData = this.$router.resolve('/offers/' + id + '/edit');
                window.open(routeData.href);
            } else {
                this.$router.push('/offers/' + id + '/edit');
            }
        },
        addClick() {
            this.$router.push('/offers/0/add');
        },
        reloadTable(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'offers', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        resolveWindowResize() {
            let offset = 205;
            //the filter panel shares the button row, so only its expanded fields add height above the table
            if (this.$refs.filterPanel) {
                offset += this.$refs.filterPanel.fieldsHeight();
            }
            this.tableData.height = window.innerHeight - offset + 'px';
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', [
            {
                class: 'help-add',
                html: this.$LANG.Get('help.add'),
                left: 0,
                top: 0,
                width: 300
            },
            {
                class: 'help-edit',
                html: this.$LANG.Get('help.edit'),
                left: 0,
                top: 0,
                width: 300
            }
        ]);
        this.$store.commit('selectMenu', 'offers');
        this.$store.commit('selectSubMenu', null);
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.offers'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
        let vm = this;
        this.crossTabHandle = this.$CROSS_TAB_BUS.ListenToEvent('reload-offers', () => {
            vm.reloadTable(vm.tableData.lastRequest);
        });
    },
    unmounted() {
        if (this.crossTabHandle !== null) {
            this.$CROSS_TAB_BUS.UnbindEvent(this.crossTabHandle);
        }
    }
}
</script>

<style scoped lang="scss">
@use '../../scss/vars' as *;

:deep(.nevs-table-header td) {
    padding-bottom: 10px !important;
}

.status-pill-1 {
    width: 100%;
    text-align: center;
    display: inline-block;
    background: $status-open;
    padding: 5px;
    border-radius: 5px;
}

.status-pill-2 {
    width: 100%;
    text-align: center;
    display: inline-block;
    background: $status-pending;
    padding: 5px;
    border-radius: 5px;
}

.status-pill-3 {
    width: 100%;
    text-align: center;
    display: inline-block;
    background: $status-done;
    padding: 5px;
    border-radius: 5px;
}

.status-pill-4 {
    width: 100%;
    text-align: center;
    display: inline-block;
    background: $status-done;
    padding: 5px;
    border-radius: 5px;
}

.status-pill-5 {
    width: 100%;
    text-align: center;
    display: inline-block;
    background: $status-cancelled;
    padding: 5px;
    border-radius: 5px;
}

.status-pill-6 {
    width: 100%;
    text-align: center;
    display: inline-block;
    background: $status-expired;
    padding: 5px;
    border-radius: 5px;
}

</style>